import dayjs from 'dayjs';
import _ from 'underscore';
import getOffsetTime from '../../../../../utils/getOffsetTime.js';
import ignoreDummyComments from '../../../../../utils/ignoreDummyComments.js';


const editTour = async ({ state, detailedSchedule, allowTourDayTypes, liveSchedule, generateTourDuration, updateState,
jobElementsByTour, tourMeals, meal, tourPayTransactions, tourPayTransaction, payTransactigenerateItemDurationonsByTour, tourIndicators,
tourIndicator, indicatorsByTour, tourActivityFlag, tourActivityFlags, activityFlagByTour,  }) => {
  const { resource, itemDetails } = state;
  // insert detailedSchedule data into itemDetails object
  itemDetails.tourDetails = await detailedSchedule;
  // insert fields into itemDetails to make 'addTour' methods reusable
  itemDetails.dayTypeId = allowTourDayTypes.find((elem) => elem.name == itemDetails.tourDetails.dayType).id;
  itemDetails.timeZoneId = 1;  // TODO: generate dynamically

  // grab resource from liveSchedule to get full tour start/end time rather than item times (i.e. pre-meal, post-meal)
  const liveScheduleResource = liveSchedule.find((elem) => {
    return elem.rId === resource.id && elem.dayTypes && elem.dayTypes[itemDetails.rdtId] && elem.dayTypes[itemDetails.rdtId].tour
  });
  // console.log('LIVE_SCHEDULE_RESOURCE:', liveScheduleResource.dayTypes[itemDetails.rdtId].tour);  // debug

  itemDetails.tourStartTime = dayjs.unix(liveScheduleResource.dayTypes[itemDetails.rdtId].tour.startTime);
  let timeZoneOffset = getOffsetTime(dayjs(itemDetails.tourStartTime));

  /**
   * INSERT TOUR DETAILS INTO ITEMDETAILS OBJECT
   *
   * adding the offset here (instead of subtracting) bc we are converting back to GMT
   * for the purposes of populating the form
   * (don't want time value that already exists for the tour to be converted based on what actual timezone user is currently in)
   */
  itemDetails.tourStartTime.add(timeZoneOffset, 'minute');
  itemDetails.tourEndTime = dayjs.unix(liveScheduleResource.dayTypes[itemDetails.rdtId].tour.endTime).add(timeZoneOffset, 'minute');
  itemDetails.mealStartTime = itemDetails.tourDetails.meals && itemDetails.tourDetails.meals.length > 0 ? dayjs.unix(itemDetails.tourDetails.meals[0].mealStart) : null;
  itemDetails.mealEndTime = itemDetails.tourDetails.meals && itemDetails.tourDetails.meals.length > 0 ? dayjs.unix(itemDetails.tourDetails.meals[0].mealEnd) : null;
  itemDetails.tourId = itemDetails.id.split('-')[0];
  itemDetails.tourComment = ignoreDummyComments(itemDetails.tourDetails.comment);
  itemDetails.myTourComment = ignoreDummyComments(itemDetails.tourDetails.comment15);
  itemDetails.notificationComment = ignoreDummyComments(itemDetails.tourDetails.notification);
  itemDetails.tourIndicators = itemDetails.tourDetails.indicators;
  itemDetails.payTransactions = itemDetails.tourDetails.payTransactions;
  itemDetails.approved = itemDetails.tourDetails.approved;
  itemDetails.salaryLevelId = itemDetails.tourDetails.salaryLevel;
  itemDetails.postTK = itemDetails.tourDetails.postTK;
  // fields that need to come from personnelData api
  // itemDetails.showBusy
  // itemDetails.baseRateId: hourlyActivityFlag === 1 ? 3 : 0,
  // itemDetails.baseOverrideType: hourlyActivityFlag === 1 ? 'EXP' : 'NON',
  // itemDetails.baseOverride: hourlyActivityFlag === 1 ? rate : 0,
  // itemDetails.jobSalaryId

  await generateTourDuration(itemDetails.tourStartTime, itemDetails.tourEndTime);


  // MEALS TAB
  let mealsTableDataSource = [];
  let selectedMeal = {};
  let selectedMealFound = false;
  let mealArrLength = tourMeals.data.length;
  if (meal) {
    for (let [idx, elem] of Object.entries(tourMeals.data)) {
      let row = {
        key: mealArrLength > 1 && !selectedMealFound ? parseInt(idx) + 1 : parseInt(idx), // only shift those before selected
        mealId: elem.mealId,
        jobElementId: elem.jobElementId
      };
      // timezone offset adjustment
      let startTime = dayjs(elem.dateTimeStartActual);
      let endTime = dayjs(elem.dateTimeEndActual);
      let timeZoneOffset = getOffsetTime(startTime);
      let mealStartTime = startTime.add(timeZoneOffset, 'minute');
      let mealEndTime = endTime.add(timeZoneOffset, 'minute');
      // update starte/end time
      row.startTime = mealStartTime.format('MM/DD/YYYY h:mm a');
      row.endTime = mealEndTime.format('MM/DD/YYYY h:mm a');

      if ((mealArrLength > 1)
      && (elem.id === tourMeals.data[0].mealId)
      ) {
        selectedMeal = row;
        selectedMeal.key = 0;
        selectedMealFound = true;
        // use off-set adjusetd time in itemDetails obj (for initial form load)
        itemDetails.mealStartTime = mealStartTime;
        itemDetails.mealEndTime = mealEndTime;
        itemDetails.jobElementId = elem.jobElementId;
      } else {
        mealsTableDataSource.push(row);
      }
    }
    // put selectedElement at the front of array; key = index = 0, so that its always on first page,
    // and you don't have to use pagination to get to it
    if (mealArrLength > 1) {
      mealsTableDataSource.unshift(selectedMeal);
    }


    // update duration in itemDetails
    await generateItemDuration('meal', dayjs(meal.data[0].startTime), dayjs(meal.data[0].endTime));
  }

  // PAY TRANSACTIONS TAB
  let tourPayTransactionsTableDataSource = [];
  let selectedTourPayTransaction = {};
  let selectedTourPayTransactionFound = false;
  let payTransactionArrLength = tourPayTransactions.data.length;
  if (tourPayTransaction) {
    for (let [idx, elem] of Object.entries(tourPayTransactions.data)) {
      let row = {
        key: payTransactionArrLength > 1 && !selectedTourPayTransactionFound ? parseInt(idx) + 1 : parseInt(idx), // only shift those before selected
        id: elem.id,
        code: elem.code,
        name: elem.name,
        assignment: elem.assignment,
        cost: elem.cost
      };

      // put payTransaction from redux at the front of array for table
      if ((payTransactionArrLength > 1)
      && (elem.id === tourPayTransaction.data[0].id)
      ) {
        selectedTourPayTransaction = row;
        selectedTourPayTransaction.key = 0;
        selectedTourPayTransactionFound = true;
      } else {
        tourPayTransactionsTableDataSource.push(row);
      }
    }
    // put selectedElement at the front of array; key = index = 0, so that its always on first page,
    // and you don't have to use pagination to get to it
    if(payTransactionArrLength > 1) {
      tourPayTransactionsTableDataSource.unshift(selectedTourPayTransaction);
    }
  }

  // INDICATORS TAB
  let tourIndicatorsTableDataSource = [];
  let selectedTourIndicator = {};
  let selectedTourIndicatorFound = false;
  let indicatorArrLength = tourIndicators.data.length;
  if (tourIndicator) {
    for (let [idx, elem] of Object.entries(tourIndicators.data)) {
      let row = {
        key: indicatorArrLength > 1 && !selectedTourIndicatorFound ? parseInt(idx) + 1 : parseInt(idx),
        id: elem.id,
        name: elem.indicatorName,
        codeName: elem.codeName,
        assignment: elem.assignment,
        cost: elem.cost
      };

      if ((indicatorArrLength > 1)
      && (elem.id === tourIndicator.data[0].id)
      ) {
        selectedTourIndicator = row;
        selectedTourIndicator.key = 0;
        selectedTourIndicatorFound = true;
      } else {
        tourIndicatorsTableDataSource.push(row);
      }
    }
    if (indicatorArrLength > 1) {
      tourIndicatorsTableDataSource.unshift(selectedTourIndicator);
    }

  }

    // ACTIVITY FLAGS TAB
    let tourActivityFlagsTableDataSource = [];
    let selectedTourActivityFlag = {};
    let selectedTourActivityFlagFound = false;
    let activityFlagArrLength = tourActivityFlags.data.length;
    if (tourActivityFlag) {
      for (let [idx, elem] of Object.entries(tourActivityFlags.data)) {
        let row = {
          key: activityFlagArrLength > 1 && !selectedTourActivityFlagFound ? parseInt(idx) + 1 : parseInt(idx),
          id: elem.id,
          name: elem.name,
          duration: elem.duration,
          jobNumber: elem.jobNumber
        };

        // timezone offset adjustment
        let startTime = dayjs(elem.startTime);
        // let endTime = dayjs(elem.endTime);
        let timeZoneOffset = getOffsetTime(startTime);
        let tourActivityFlagStartTime = startTime.add(timeZoneOffset, 'minute');

        row.startTime = tourActivityFlagStartTime.format('h:mm a');

        if ((activityFlagArrLength > 1)
        && (elem.id === tourActivityFlag.data[0].id)
        ) {
          selectedTourActivityFlag = row;
          selectedTourActivityFlag.key = 0;
          selectedTourActivityFlagFound = true;
        } else {
          tourActivityFlagsTableDataSource.push(row);
        }
      }
      if (activityFlagArrLength > 1) {
        tourActivityFlagsTableDataSource.unshift(selectedTourActivityFlag);
      }
    }

  await updateState({
    itemDetails,
    jobElementsByTour,
    mealsTableDataSource,
    tourMeals,
    meal,
    tourPayTransactionsTableDataSource,
    tourPayTransactions,
    tourPayTransaction,
    payTransactionsByTour,
    tourIndicatorsTableDataSource,
    tourIndicators,
    tourIndicator,
    indicatorsByTour,
    tourActivityFlagsTableDataSource,
    tourActivityFlags,
    tourActivityFlag,
    activityFlagByTour,
    loading: false
  });
};

export default editTour;
